import { ViewMode } from "../constants/enum.pos";

export class Coupon {
	id: string;
	name: string;
	type: string;
	value: number;
	expiryDate: string;
	isDisabled: boolean;
	isNeverExpire: boolean;
}

export interface CouponType {
	id: string;
	name: string;
}

export interface CouponDataView {
	coupon: Coupon;
	viewMode: ViewMode;
}
